import React from "react";

export const Section = (props) => (
  <section id={props.tag} className={props.light ? ('io-section light') : (props.theme ? 'io-section ' + props.theme : 'io-section')}>
    <div className="title">
      {props.title && <p>{props.title}</p>}
    </div>
    {props.children}
  </section>
)